import Modal from "../shared/Modal";
import { Employee, getDefaultUserAvatar } from "winslow-core";
import "./ModalMatchingEmployees.css";
import { useSelector } from "react-redux";
import { selectHrisConnected } from "../../redux/features/appData/appDataSlice";
import { useNavigate } from "react-router-dom";

type ModalMatchingEmployeesProps = {
  isOpen: boolean;
  onClose: () => void;
  employees: Employee[];
  title?: string;
};

export const ModalMatchingEmployees = ({
  isOpen,
  onClose,
  employees,
  title,
}: ModalMatchingEmployeesProps) => {
  const hrisConnected = useSelector(selectHrisConnected);
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "512px" }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="matching-employees-modal-container">
        <header className="matching-employees-modal-header">
          {!hrisConnected && (
            <h1
              className="matching-employees-modal-title clickable"
              onClick={() => {
                navigate("/workspaces?tab=4");
              }}>
              Connect HRIS
            </h1>
          )}
          {hrisConnected && (
            <h1 className="matching-employees-modal-title">
              {title ||
                (employees.length === 0
                  ? "No Matching Employees"
                  : employees.length === 1
                    ? "1 Matching Employee"
                    : `${employees.length} Matching Employees`)}
            </h1>
          )}
        </header>

        <div className="matching-employees-list">
          {employees.map((employee) => (
            <div key={employee.id} className="matching-employee-item">
              <img
                src={
                  (employee as any)?.profile?.avatar ||
                  getDefaultUserAvatar(
                    (employee as any).displayName ||
                      (employee as any).displayFullName
                  ) ||
                  ""
                }
                alt={getDefaultUserAvatar(
                  (employee as any).displayName ||
                    (employee as any).displayFullName
                )}
                className="matching-employee-avatar"
              />
              <span className="matching-employee-name">
                {(employee as any).displayName ||
                  (employee as any).displayFullName}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};
